module.exports = {
    home:                         'Strona główna',
    channels:                     'Kanały',
    lastChannelUpdates:           'Ostatnie aktualizacje kanałów',
    topics:                       'Tematy',
    noTitle:                      'Brak tytułu',
    noDescription:                'Nie znaleziono opisu',
    imageMap:                     'Mapa obrazu',
    de:                           'niemiecki',
    en:                           'angielski',
    contact:                      'Kontakt',
    imprint:                      'Odbitka',
    legal:                        'Prawny',
    downloads:                    'Pobieranie',
    downloadTitle:                'Pobierz wideo:',
    downloadDescription:          '',
    directLinks:                  'Link',
    directLinkTitle:              'Link do wideo',
    directLinkDescription:        '',
    shortlink:                    'Skrócony link',
    //
    browseCategories:             'Wybierz kategorię',
    //
    prepareDownload:              'Przygotowywanie do pobrania...',
    //
    contactPerson:                'Osoba kontaktowa',
    contactCompany:               'Firma',
    contactOccupation:            'Zawód',
    contactPhone:                 'Telefon',
    contactEmail:                 'E-mail',
    mediahubTechError:            'Wystąpił błąd podczas próby wyświetlenia tej strony. Skontaktuj się z osobą, która wysłała Ci ten link.',
    mediahubNotYetAvailable:      'Ta strona nie jest jeszcze dostępna. Proszę odwiedzić ją ponownie ',
    mediahubNoLongerAvailable:    'Ta strona nie jest dostępna od ',
    mediahubMaxDownloads:         'Osiągnięto maksymalną liczbę żądań dla tej strony.',
    zoomTurnedOff:                'Włącz zoom obrazu',
    zoomTurnedOn:                 'Wyłącz zoom obrazu',
    //dodatkowe informacje
    additionalMedia:              'Dodatkowe pliki do pobrania',
    additionalMediaContainer:     'Więcej filmów na temat',
    moreVideos:                   'Więcej filmów',
    start:                        'Dostępne od:',
    end:                          'do:',
    //uwierzytelnianie
    authenticationRequired:       'Wymagane uwierzytelnianie, aby uzyskać dostęp do tej strony.',
    authUsername:                 'Nazwa użytkownika',
    authPassword:                 'Hasło',
    authLogin:                    'Zaloguj się',
    authWrong:                    'Błędne uwierzytelnianie. Spróbuj ponownie.',
    //związane z wideo
    videoSize:                    'Rozmiar',
    fileSize:                     'Rozmiar pliku',
    formatDownloads:              'Formaty pobierania',
    download:                     'Pobierz',
    mediaNotAvailable:            'Wideo nie jest dostępne do pobrania.',
    // Jakość wideo
    hd:                           'HD',
    timeout:                      'Strona przekroczyła czas oczekiwania.',
    timeoutDescription:           'Z powodów bezpieczeństwa ta strona była ważna przez określony czas. Użyj przycisku odświeżania w przeglądarce, aby powrócić do strony.',
    noDataForMediaHub:            'Brak plików multimedialnych',
    noDataForMediaHubDescription: 'Nie ma plików multimedialnych związanych z tym mediahubem.',
    mediahub:                     'MediaHub',
    loading:                      '...ładowanie',
    //media
    title:                        'Tytuł',
    description:                  'Opis',
    videoDescription:             'Opis',
    mediaDescription:             'Opis',
    //wyszukiwanie
    search:                       'Szukaj',
    searchResults:                'Wyniki',
    // Nakładka odtwarzacza
    playerOverlayViews:           'Odsłony:',
    playerOverlayDate:            'Data:',
    playerOverlayTags:            'Tagi:',
    // Chlebki
    breadcrumbYouAreHere:         'Jesteś tutaj:',
    breadCrumbHomepage:           'Strona główna',
    breadCrumbSlider:             'W suwaku',
    // Błędy
    unauthorized:                 '401 - Nieautoryzowany',
    forbidden:                    '403 - Zakazany',
    notFound:                     '404 - Nie można znaleźć publicznej przestrzeni.',
    serverError:                  '500 - Wewnętrzny błąd serwera',
    error404p1:                   'Strona, której szukasz, nie została odnaleziona.',
    error404p2:                   'Sprawdź adres.',
    error404p3:                   'W celu uzyskania dodatkowych informacji skontaktuj się z nami ',
    error404contact:              'tutaj',
    //puste
    emptyString:                  ' ',
    backToOverview:               'Powrót do przeglądu',
    showAll:                      'Pokaż wszystko',
    showMore:                     'Pokaż więcej filmów',
    all:                          'Wszystko',
    filter_countEmbeds:           'Najczęściej oglądane filmy',
    filter_createdAt:             'Najnowsze filmy',
    filter_publishedDate:         'Najnowsze filmy',
    noCreationDate:               'Brak daty utworzenia',
    video:                        'Filmy',
    watchVideo:                  'Obejrzyj film',
    sharePost:                    'Udostępnij ten film',
  };
  


// WEBPACK FOOTER //
// ./src/stores/i18n/pl.js